<template>
  <!-- 公告信息 -->
  <div class="noticeList full-height bg-lightGray">
    <ld-header>
      {{ $route.query.msgType | title }}
    </ld-header>

    <div class="wrapper">
      <mescroll-vue
        ref="mescroll"
        :down="down"
      >
        <van-pull-refresh
          v-model="tab.pullRefreshLoading"
          @refresh="onRefresh(tab)"
        >
          <van-list
            v-model="tab.loading"
            :finished="tab.finished"
            :error.sync="tab.error"
            :error-text="tab.errorText"
            :finished-text="tab.finishedText"
            @load="tab.pageNum++; getList(tab);"
          >
            <div class="list">
              <div
                v-for="el in tab.list"
                :key="el.msgType"
                style="padding: 20px;"
                @click="$router.push({ path: `/userCenter/noticeDetail/${el.tzId || el.id}` })"
              >
                <van-cell style="border-top-left-radius:10px;border-top-right-radius:10px;">
                  <van-row>
                    <van-col
                      span="12"
                      class="van-ellipsis"
                    >
                      <svg
                        class="svg-icon font22"
                        aria-hidden="true"
                      >
                        <use :xlink:href="el.msgType | icon" />
                      </svg>&nbsp;
                      <span class="font16">{{ el.tzTitle }}</span>
                    </van-col>
                    <van-col
                      span="12"
                      class="text-right gray"
                    >
                      {{ el.savedate }}
                    </van-col>
                  </van-row>
                </van-cell>
                <van-cell>
                  <div class="deep-gray van-multi-ellipsis--l2">
                    {{ el.ydContent }}
                  </div>
                </van-cell>
                <van-cell style="border-bottom-left-radius:10px;border-bottom-right-radius:10px;">
                  <van-row
                    class="deep-gray"
                  >
                    <van-col span="18" />
                    <van-col
                      span="6"
                      class="text-right"
                    >
                      查看详情
                    </van-col>
                  </van-row>
                </van-cell>
              </div>
            </div>
          </van-list>
        </van-pull-refresh>
      </mescroll-vue>
    </div>
  </div>
</template>

<script>
import { Panel, Tab, Tabs, List, Button, Field, PullRefresh,Cell } from 'vant'
import MescrollVue from 'mescroll.js/mescroll.vue'

export default {
  name: 'NoticeList',
  components: {
    [Panel.name]: Panel,
    [Tab.name]: Tab,
    [Tabs.name]: Tabs,
    [List.name]: List,
    [Field.name]: Field,
    [Button.name]: Button,
    [PullRefresh.name]: PullRefresh,
    [Cell.name]: Cell,
    MescrollVue
  },
  data () {
    return {
      active: 0,
      tabList: [
        {
          pageNum: 0,
          count: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          list: [],
          pullRefreshLoading: false,
          title: this.$t('A136','未读'),
          total: 0
        },
        {
          pageNum: 0,
          count: 10,
          loading: false,
          finished: false,
          finishedText: '没有更多数据了~',
          error: false,
          errorText: '请求失败，点击重新加载',
          list: [],
          pullRefreshLoading: false,
          title: this.$t('A135','已读'),
          total: 0
        }
      ],
      tab: {
        pageNum: 0,
        count: 10,
        loading: false,
        finished: false,
        finishedText: '没有更多数据了~',
        error: false,
        errorText: '请求失败，点击重新加载',
        list: [],
        pullRefreshLoading: false,
        title: this.$t('A135','已读'),
        total: 0
      },
      mapCount: { zs: 0, yds: 0, wds: 0 },
      down:{ use: false },
      noticeType:[],
    }
  },
  created () {
  },
  methods: {
    onRefresh(tab) {
      tab.list = []
      tab.pageNum = 1
      tab.pullRefreshLoading = false
      this.getList(tab)
    },
    // 获取消息列表
    getList (tab) {
      if (tab.pageNum === 0) return
      tab.loading = true
      //1系统消息、2订单通知、3审批信息、4航变信息、5企业通知 
      this.$api['common/findGgtzByMsgType']({
        'msgType': this.$route.query.msgType,
        'productType': ''
      }).then(res => {
        var data = res.data ? res.data.list ? res.data.list : [] : []
        tab.loading = false
        if (data.length < 10) {
          tab.finished = true
        }
        if (tab.pageNum > 1) {
          tab.list.push(...data)
        } else {
          tab.list = data
        }
      })
    },
  },
  activated () {
    this.onRefresh(this.tabList[this.active])
  },
  filters:{
    icon(val){
      var obj={
        1:'#iconweibiaoti-3',
        2:'#iconweibiaoti-129',
        3:'#iconweibiaoti-127',
        4:'#iconweibiaoti-128',
        5:'#iconweibiaoti-131',
      }
      return obj[val]||''
    },
    title(val){
      var obj={
        1:'系统消息',
        2:'订单通知',
        3:'审批信息',
        4:'航变信息',
        5:'企业通知',
      }
      return obj[val]||''
    }
  }
}
</script>

<style lang="less" scoped>
    .list{
        padding: 5px;
    }
.noticeList {
  h3 {
    margin: 0;
  }

  .wrapper {
    height: calc(100vh - 107px);
    overflow: hidden;
  }

  .van-tab__pane {
    font-size: @font-size-12;
  }

  .notice-panel {
    overflow: auto;
    margin: 25px;
    padding: 12px 12px 0;
    border-radius: 10px;
  }
}
</style>
